export default "__VITE_ASSET__eRpi$toL__"